import { put, select, takeEvery, call } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_BROADCAST_MESSAGE,
    SYSTEM_EDIT_BROADCAST_MESSAGE,
    GET_BROADCAST_MESSAGE,
} from 'store/key';
import { produce } from 'utility/general';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

const initialState = {
    broadcastMessage: {
        id: null,
        text: ''
    },
    news: {
        id: null,
        text: ''
    },
};

function* getBroadCastMsg(action) {
    const { broadcastMessage } = yield select();
    yield put({
        type: SET_BROADCAST_MESSAGE,
        payload: {
            isLoading: true,
        }
    });
    try {
        const res = yield call(API.system.getNews, {});
        for (let i of res.data.result) {
            if (i.type === 'BROADCAST') {
                broadcastMessage.broadcastMessage = i;
            }
            if (i.type === 'NEWS') {
                broadcastMessage.news = i;
            }
        }

        yield put({
            type: SET_BROADCAST_MESSAGE,
            payload: broadcastMessage
        });
    } catch (err) {
        console.log("global variables's error: ", err);
    };
    yield put({
        type: SET_BROADCAST_MESSAGE,
        payload: {
            isLoading: false,
        }
    });
};

function* editBroadcastMessage(action) {
    const { id, data, callback } = action.payload;

    setGlobalLoading(true);
    try {
        const res = yield call(API.system.updateNews, { id, data });

        if (res.status === 200) {
            callback?.();
        }
    } catch (err) {
        console.log("global variables's error: ", err);
    };
    setGlobalLoading(false);
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BROADCAST_MESSAGE:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchBroadcastMessage() {
    yield takeEvery(SYSTEM_EDIT_BROADCAST_MESSAGE, safeSaga(editBroadcastMessage));
    yield takeEvery(GET_BROADCAST_MESSAGE, safeSaga(getBroadCastMsg));
}

export default reducer;
